/**
 * Better Auth Client Configuration
 * 
 * Configured to use React hooks for authentication state management.
 */

import { createAuthClient } from "better-auth/react";
import { getApiBaseUrl } from "./runtime-config";

const apiBaseUrl = getApiBaseUrl() || window.location.origin;

export const authClient = createAuthClient({
  baseURL: apiBaseUrl,
  fetchOptions: {
    credentials: "include",
  },
});

// Export individual methods for convenience
export const { 
  signIn, 
  signUp, 
  signOut, 
  useSession,
  updateUser,
  sendVerificationEmail,
} = authClient;
